import ENGLISH_TRANSLATIONS from './EnglishTranslations';

export default {
  en: ENGLISH_TRANSLATIONS,
};
